import * as React from 'react';
import styles from './index.less';
import { Space } from 'antd';
import FComponentsLib from '@freelog/components-lib';
import FPopover from '@/components/FPopover';
import { FI18n } from '@freelog/tools-lib';
// import fResourcePropertyEditor from '@/components/fResourcePropertyEditor';
import fResourcePropertyEditor3 from '@/components/fResourcePropertyEditor3';

interface TipPopoverProps {
  info: {
    key: string;
    name: string;
    description: string;
  };
  children: React.ReactNode;
  type?: 'property' | 'option';
  refContainer: React.RefObject<HTMLDivElement>;
  configs: {
    key_Editable: boolean;
    name_Editable: boolean;
    description_Editable: boolean;
  };
  disabledKeys: string[];
  disabledNames: string[];
  onChange?: (res: { key: string; name: string; description: string }) => void;
}

function TipPopover({
  info,
  children,
  type = 'property',
  refContainer,
  configs,
  disabledKeys,
  disabledNames,
  onChange,
}: TipPopoverProps) {
  return (
    <FPopover
      // visible={true}
      // trigger={['hover']}
      title={null}
      getPopupContainer={() => {
        // console.log('refContainer ))))))))))))))))))', refContainer.current);
        return refContainer.current as HTMLElement;
      }}
      placement={'bottomLeft'}
      content={
        <Space size={15} direction={'vertical'} style={{ width: 320 }}>
          <div>
            <FComponentsLib.FContentText
              type={'additional2'}
              text={
                type === 'property'
                  ? // ? '属性名称'
                    FI18n.i18nNext.t('resourceinfo_info_name')
                  : // : '配置名称'
                    FI18n.i18nNext.t('resourceoptions_info_name')
              }
            />
            <div style={{ height: 5 }} />
            <FComponentsLib.FContentText
              type={'normal'}
              text={info.name}
              style={{ maxWidth: 320, wordBreak: 'break-all' }}
            />
          </div>
          <div>
            <FComponentsLib.FContentText
              type={'additional2'}
              text={
                type === 'property'
                  ? FI18n.i18nNext.t('resourceinfo_info_key')
                  : FI18n.i18nNext.t('resourceoptions_info_key')
              }
            />
            <div style={{ height: 5 }} />
            <FComponentsLib.FContentText
              type={'normal'}
              text={info.key}
              style={{ maxWidth: 320, wordBreak: 'break-all' }}
            />
          </div>
          {info.description && (
            <div>
              <FComponentsLib.FContentText
                type={'additional2'}
                text={
                  type === 'property'
                    ? // ? '属性说明'
                      FI18n.i18nNext.t('resourceinfo_info_desc')
                    : // : '配置说明'
                      FI18n.i18nNext.t('resourceoptions_info_desc')
                }
              />
              <div style={{ height: 5 }} />
              <FComponentsLib.FContentText
                type={'normal'}
                text={info.description}
                style={{ maxWidth: 320, wordBreak: 'break-all' }}
              />
            </div>
          )}
          {(configs.key_Editable ||
            configs.name_Editable ||
            configs.description_Editable) && (
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <FComponentsLib.FTextBtn
                type={'primary'}
                onClick={async () => {
                  const res = await fResourcePropertyEditor3({
                    disabledKeys: disabledKeys,
                    disabledNames: disabledNames,
                    defaultData: {
                      key: info.key,
                      name: info.name,
                      description: info.description,
                    },
                    noneEditableFields: [
                      ...(configs.key_Editable ? [] : ['key' as const]),
                      ...(configs.name_Editable ? [] : ['name' as const]),
                      ...(configs.description_Editable
                        ? []
                        : ['description' as const]),
                    ],
                  });
                  // console.log('res **************', res);
                  if (res) {
                    onChange?.(res);
                  }
                }}
                style={{ fontSize: 12 }}
              >
                {FI18n.i18nNext.t('resourceinfo_btn_edit')}
              </FComponentsLib.FTextBtn>
            </div>
          )}
        </Space>
      }
    >
      <div>{children}</div>
    </FPopover>
  );
}

export default TipPopover;
